import React from "react";
import Container from "@mui/material/Container";

// Container for workspace pages (library, search, project tabs): fluid up to 1920px, gutters grow with the screen.
// Forms and reading pages keep MUI's fixed widths (lg / sm / xs).
export default function WideContainer({ className, ...props }) {
  return <Container {...props} maxWidth={false} className={"vv-wide" + (className ? " " + className : "")} />;
}
